import { CALIFORNIA, FLORIDA, NORTH_DAKOTA } from "../../../Helpers/Constants/States";

const nicotineUsageRadios = [
    { value: "Within the last year", label: "Within the last year" },
    { value: "Within the last 13-36 months", label: "Within the last 13-36 months" },
    { value: "Over 36 months", label: "Over 36 months ago" },
    { value: "Never", label: "Never" }
  ];

const getLabelForAids = (state) => {
    if (state === CALIFORNIA) {
        return " Have you ever been diagnosed, treated or prescribed medication by a licensed member of the medical profession for AIDS or ARC or had a positive test for HIV antibodies in connection with an application for insurance?";
    } else if (state === FLORIDA) {
        return "To the best of your knowledge and belief, have you ever tested positive for the HIV infection or been diagnosed by a licensed member of the Medical profession as having ARC or AIDS caused by the HIV infection or other sickness or conditions derived from such infection?";
    } else if (state === NORTH_DAKOTA) {
        return "Have you ever been diagnosed as having, been treated by a licensed member of the medical profession for AIDS, AIDS-related Complex or tested positive for antibodies to HIV?";
    } else {
        return "Have you ever been diagnosed by a licensed member of the medical profession or tested positive for Human Immunodeficiency Virus (HIV) or Acquired Immune Deficiency Syndrome (AIDS)?";
    }
}

const getLabelForMedicalIssues = (state) => {
    if (state === CALIFORNIA) {
        return "Have you ever been diagnosed with, or received care or treatment for";
    } else if (state === FLORIDA) {
        return "To the best of your knowledge and belief, in the past 10 years have you been diagnosed, received care or treatment for, or consulted with or been advised to seek treatment by a licensed member of the medical profession for";
    } else {
        return "In the past 10 years have you been diagnosed, received care or treatment for, or consulted with or been advised to seek treatment by a licensed member of the medical profession for";
    }
}

const getLabelForDiabetes = (state) => {
    if (state === CALIFORNIA) {
        return "Have you ever been diagnosed with, or received care or treatment for Diabetes?";
    } else if (state === FLORIDA) {
        return "To the best of your knowledge and belief, in the past 10 years have you been diagnosed, received care or treatment for, or consulted with or been advised to seek treatment by a licensed member of the medical profession for Diabetes?";
    } else {
        return "In the past 10 years have you been diagnosed, received care or treatment for, or consulted with or been advised to seek treatment by a licensed member of the medical profession for Diabetes?";
    }
}

export { nicotineUsageRadios, getLabelForAids, getLabelForMedicalIssues, getLabelForDiabetes };


// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/Helpers/MedicalHistoryData.js